import React, { useState } from 'react';

//components
import RecipeForm from '../components/forms/RecipeForm';

//page for creating a new recipe
function CreateRecipe() {
    return (
        <div>
            {/* <h1>Create Recipe</h1> */}
            <RecipeForm />
        </div>
    );
}

export default CreateRecipe;


